module.exports = __webpack_public_path__ + "img/16m008-07.e0dbbe71.png";